<template>
  <div class="grid-main bg-purple ">

    <h2 style="float: left">用户列表</h2>
    <el-button type="primary" @click="openoperatorUser()">添加用户</el-button>


    <div class="table-box" >

      <el-table
        :data="qtuserList.list"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="operatorName"
          label="所属企业"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="用户名"
        >
        </el-table-column>
        <el-table-column

          label="头像">
          <template slot-scope="scope">
            <img :src="scope.row.avatar" alt="" style="width: 64px;
                                       height: 64px;
                                       border: 2px solid #FFFFFF;
                                       border-radius: 50%;"/>
          </template>
        </el-table-column>
        <el-table-column
          label="有效期">
          <template slot-scope="scope">
            {{scope.row.periodStart | myFuncton}}至{{scope.row.periodEnd | myFuncton}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right">
          <template slot-scope="scope">

            <el-button
              v-if="scope.row.id>1"
              size="mini"
              type="danger"
              @click="openDelete(scope.row.id)">删除</el-button>
            <!-- <el-button
            type="success"
            size="mini"
             @click="openuserrole(scope.row.id)">分配角色</el-button> -->
<!--            <el-button-->
<!--              type="success"-->
<!--              v-if="scope.row.id>1"-->
<!--              size="mini"-->
<!--              @click="openoperatorUser(scope.row.id)">分配企业</el-button>-->


          </template>
        </el-table-column>

      </el-table>
      <el-pagination
      	v-if="qtuserList.userListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="qtuserList.pageSize"
        @current-change="setqtUserList"
        :total="qtuserList.userListtotal">

      </el-pagination>
    </div>




  <!--修改用户分配账号-->
  <el-dialog  :visible.sync="dialogoperatorUser" width="30%" :before-close="dialogrouserFormclose">
    <el-form ref="form"  label-width="150px">
      <el-form-item label="选择企业：">
        <el-select v-model="AllOperatorvalue" placeholder="请选择">
          <el-option
            v-for="item in AllOperator"
            :key="item.id"
            :label="item.operatorName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="operatorUser()" style="margin-left: -50px">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>







  <el-dialog  :visible.sync="dialoguserFormVisiblesz" :before-close="dialogrouserFormclose">
    <el-form ref="form"  label-width="150px">
      <el-form-item label="选择企业：">
        <el-select v-model="qtform.AllOperatorvalue" placeholder="请选择">
          <el-option
            v-for="item in AllOperator"
            :key="item.operatorNum"
            :label="item.operatorName"
            :value="item.operatorNum">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="头像：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="用户名：">
        <el-input v-model="qtform.name" placeholder="用户名" autocomplete="new-password"></el-input>
      </el-form-item>

      <el-form-item label="密码：">
        <el-input v-model="qtform.pwd" type="password" placeholder="密码" autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：">
        <el-input v-model="qtform.spwd" type="password" placeholder="确认密码" autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="用户有效期：">
        <el-col :span="11">
          <el-date-picker type="date" placeholder="开始日期"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss" v-model="qtform.date1" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker ype="date" placeholder="结束日期"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss"   v-model="qtform.date2" style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onqtSubmit">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>



  </div>
</template>

<script>
export default {
  name: "Users",
  data(){
    return {

      //用户列表
      phoness:'',
      dialoguserFormVisiblesz: false,

      qtuserList:{
        list:[],
        userListpage:1,
        userListtotal:0,
        pageSize:10,
      },
      qtform: {
        AllOperatorvalue:'',
        avatar:'',
        name: '',
        phone:'',
        pwd: '',
        spwd: '',
        date1: '',
        date2: '',
      },

      //分配用户
      dialogoperatorUser:false,
      //所有企业
      AllOperator:{},
      AllOperatorvalue:'',
      afileUrl:'/api/upload/imgs',
      fileimg:'',

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.qtUserList();
  },
  methods: {
    dialogrouserFormclose(){
      this.dialoguserFormVisiblesz=false;
      this.dialogoperatorUser=false;
      this.fileimg='';
      this.qtform={
        AllOperatorvalue:'',
        avatar:'',
        name: '',
        phone:'',
        pwd: '',
        spwd: '',
        date1: '',
        date2: '',
      };
      this.AllOperatorvalue=''
    },
    //用户管理
    //通用上传
    handleimgSuccess(res, file) {
      let that = this;

      if(res.data.errno==0){
        that.fileimg = res.data.data[0];
      }else{
        that.$message.error('上传失败');
      }
    },

    //图片检验
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // useropen(){
    //   this.dialoguserFormVisiblesz=true;
    // },

    //新增用户
    onqtSubmit() {
      let that = this;
      if (that.qtform.AllOperatorvalue == '') {
        that.$message.error("请选择企业");
        return false;
      }
      that.qtform.avatar = that.fileimg;

      if (that.qtform.avatar == '') {
        that.$message.error("请上传头像");
        return false;
      }
      if (that.qtform.name == '') {
        that.$message.error("请输入用户名");
        return false;
      }

      if (that.qtform.pwd == '') {

        that.$message.error("请输入密码");
        return false;
      }
      if (that.qtform.spwd == '') {
        that.$message.error("请输入确认密码");
        return false;
      }

      if (that.qtform.pwd != that.qtform.spwd) {
        that.$message.error("账号密码不一致");
        return false;
      }
      if (that.qtform.date1 == '') {
        that.$message.error("请输入有效期开始日期");
        return false;
      }

      if (that.qtform.date2 == '') {
        that.$message.error("请输入有效期结束日期");
        return false;
      }
      let qtformdata = {
        operatorNum:that.qtform.AllOperatorvalue,
        avatar: that.qtform.avatar,
        userName:that.qtform.name ,
        passWord:that.qtform.pwd,
        confirmPassword:that.qtform.spwd,
        periodStart:that.qtform.date1,
        periodEnd:that.qtform.date2
      }
      this.$axios
        .post('/api/webUser/addUser', qtformdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("账号添加失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '账号添加成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

            // this.show == true;
            // location.reload();
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //用户列表
    qtUserList(){
      let that = this;
      let qtuserdata = {
        page:this.qtuserList.userListpage,
        pageSize:this.qtuserList.pageSize,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/webUser/getUserList',qtuserdata)
        .then(function (res) {
          if(res.data.code==200){

            that.qtuserList.list = res.data.data.list;
            that.qtuserList.userListtotal = res.data.data.total;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setqtUserList(qtuserListpage){
      this.qtuserList.userListpage = qtuserListpage;
      this.qtUserList();
    },
    openDelete(qtuserId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.qtuserbatchDelete(qtuserId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除用户
    qtuserbatchDelete(qtuserId){
      let that = this;
      let userIdas = {
        userIds:[]
      }
      userIdas.userIds.push(qtuserId);
      this.$axios
        .post('/api/webUser/batchDelete',userIdas)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    getUserOperator(){
      var that = this;
      var UserOperatordata = {
        userId:that.userId,
      }
      this.$axios
        .post('/api/operator/getUserOperator',UserOperatordata)
        .then(function (res) {
          that.AllOperatorvalue = res.data.data.operatorNum;
          console.log(that.AllOperatorvalue)
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },

    openoperatorUser(userId){
    	this.qtform={
        AllOperatorvalue:'',
        avatar:'',
        name: '',
        phone:'',
        pwd: '',
        spwd: '',
        date1: '',
        date2: '',
      }
      this.selectAllOperator();
      // this.userId = userId;
      // this.getUserOperator();

      window.setTimeout(() => {
        //this.dialogoperatorUser = true;
        this.dialoguserFormVisiblesz=true
      },100);

    },

    //获取所有企业
    selectAllOperator(){
      let that = this;
      this.$axios
        .get('/api/operator/selectAllOperator')
        .then(function (res) {
          if(res.data.code == 200){
            that.AllOperator = res.data.data;


          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    //企业分配用户
    operatorUser(){
      let that = this;
      let operatorIds = {
        operatorNum:that.AllOperatorvalue,
        userId:that.userId
      }
      this.$axios
        .post('/api/operator/operatorUser',operatorIds)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '分配成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },


  },
  filters:{ //钩子
    myFuncton(date_time){

      //去掉日期数据中的T 和Z
      //by XiaoMa
      if (date_time !=null){

        let date=new Date(+new Date(date_time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
        return date
      }else {
        return date_time
      }

    },


  },
  watch: {

  },
}
</script>

<style scoped>
/deep/ .el-button--primary {
  width: auto!important;
  margin-bottom: 10px;
  margin-top:15px!important;
  float: right;
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}
/deep/ .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
/deep/ .avatar {
  width: 60px;
  height: 60px;
  display: block;
}
/deep/ .el-select{float: left}
.el-col-2{line-height: 40px}
</style>



// WEBPACK FOOTER //
// src/view/admin/Users.vue